var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterBlackV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 17.5C11.5 18.6046 10.6046 19.5 9.5 19.5C8.39543 19.5 7.5 18.6046 7.5 17.5C7.5 16.3954 8.39543 15.5 9.5 15.5C10.6046 15.5 11.5 16.3954 11.5 17.5ZM12.6632 19C12.1015 20.1825 10.8962 21 9.5 21C8.1038 21 6.89855 20.1825 6.33682 19H3.25C2.69772 19 2.25 18.5523 2.25 18C2.25 17.4477 2.69772 17 3.25 17H6.03544C6.27806 15.3039 7.73676 14 9.5 14C11.2632 14 12.7219 15.3039 12.9646 17L21 17C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19L12.6632 19Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 6.5C17.5 7.60457 16.6046 8.5 15.5 8.5C14.3954 8.5 13.5 7.60457 13.5 6.5C13.5 5.39543 14.3954 4.5 15.5 4.5C16.6046 4.5 17.5 5.39543 17.5 6.5ZM18.6632 8C18.1015 9.18247 16.8962 10 15.5 10C14.1038 10 12.8985 9.18247 12.3368 8L3 8C2.44772 8 2 7.55228 2 7C2 6.44772 2.44772 6 3 6L12.0354 6C12.2781 4.30385 13.7368 3 15.5 3C17.2632 3 18.7219 4.30385 18.9646 6H21C21.5523 6 22 6.44772 22 7C22 7.55229 21.5523 8 21 8L18.6632 8Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBlackV2);
export default __webpack_public_path__ + "static/media/FilterBlack_v2.4b6fba282c46479f8f07a40d553c986e.svg";
export { ForwardRef as ReactComponent };